import { DialogRef } from '@angular/cdk/dialog';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { EmsServicesService } from 'src/app/module/ems-master/services/ems-services.service';
import { InvoiceService } from 'src/app/module/invoices/invoice-service/invoice.service';
import * as JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { HttpClient } from '@angular/common/http';
import { ordersService } from 'src/app/module/orders/services/orders.service';
import { SharedService } from 'src/app/shared/shared.service';
import { STATUS } from 'src/app/constants/status.constant';
import { AssociateOrderAcceptComponent } from 'src/app/module/orders/components/associate-order-accept/associate-order-accept.component';
import { AddordersComponent } from 'src/app/module/orders/components/add-orders/add-orders.component';
import { MessageService } from 'primeng/api';


@Component({
  selector: 'app-details-common',
  templateUrl: './view-details.component.html',
  styleUrls: ['./view-details.component.css'],
})
export class ViewDetailsComponent {
  STATUS = STATUS;
  rowData: any;
  columns: any[];
  triggeredColumn: any;
  printData: boolean = false;
  componentName: any;
  pageNumber = 0;
  pageSize = 500;
  userDetails: any;
  userType: any;
  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private ordersService: ordersService,
    private emsServices: InvoiceService,
    public sharedService: SharedService,
    public dialogService: DialogService,
    private messageService: MessageService
  ) {
    this.userDetails = JSON.parse(localStorage.getItem('UserDetails')!);
    this.userType = this.userDetails?.userType;
    this.rowData = this.config.data.rowData;
    this.columns = this.config.data.columns;
    this.triggeredColumn = this.config.data.triggeredColumn;
    this.componentName = this.config.data.componentName;


  }
  columnPairs: any[][] = [];

  ngOnInit(): void {

    this.setColumnPairs();

  }
  setColumnPairs() {
    this.columnPairs = [];
    for (let i = 0; i < this.columns.length; i += 2) {
      this.columnPairs.push([this.columns[i], this.columns[i + 1]]);
    }
  }

  closeDialog() {
    this.ref.close();
  }

  getColumnPairs(columns: any[]): any[][] {
    const pairs = [];
    for (let i = 0; i < columns.length; i += 2) {
      pairs.push([columns[i], columns[i + 1]]);
    }
    return pairs;
  }

  isArrayOfObjects(value: any): boolean {
    return (
      Array.isArray(value) && value.length > 0 && typeof value[0] === 'object'
    );
  }

  getFormattedValue(key: any): any {
    if (!this.rowData || !this.rowData[key]) return '';

    const value = this.rowData[key];
    if (key === 'status') {
      return value == 1 ? 'Active' : 'Inactive';
    }

    if (key === 'invoiceUrl') {
      return '';
    }

    return value;
  }



  getDisplayValue(obj: any): string {
    return obj?.name || obj?.label || JSON.stringify(obj);
  }





    getStatusText(value: string): string {
    switch (value) {
      case 'PendingOnVendor': return 'Pending On Vendor';
      case 'AcceptedByVendor': return 'Accepted By Vendor';
      case 'RejectedByVendor': return 'Rejected By Vendor';
      case 'PendingOnCustomer': return 'Pending On Customer';
      case 'AcceptedByCustomer': return 'Accepted By Customer';
      case 'RejectedByCustomer': return 'Rejected By Customer';
      case 'AcceptedByUser': return 'Accepted By User';
      case 'RejectedByUser': return 'Rejected By User';
      default: return value;
    }
  }




  async downloadInvoices(data: any) {
    const zip = new JSZip();

    for (const item of data) {
      if (item.lineItemApprovalStatus === 'REJECTED') {
        console.log(`Skipping rejected item: ${item.expense}`);
        continue;
      }
      try {

        const response = await fetch(item.invoiceUrl);
        const blob = await response.blob();
        const fileName = item.invoiceUrl.split('/').pop() || 'invoice.pdf';
        const folder = zip.folder(item.expense);
        folder?.file(fileName, blob);
      } catch (err) {
        console.error('Failed to download:', err);
      }
    }

    zip.generateAsync({ type: 'blob' }).then((content) => {
      saveAs(content, 'invoices.zip');
    });
  }

  searchTerm: string = '';

  labors = [
    { name: 'Akash', age: 44, experience: 12, availability: 'Yes', selected: false },
    { name: 'Raj', age: 33, experience: 6, availability: 'Yes', selected: false },
    { name: 'Raju', age: 23, experience: 2, availability: 'No', selected: false },
    { name: 'Rj', age: 23, experience: 1, availability: 'Yes', selected: false },
  ];

  filteredLabors = [...this.labors];

  get allAvailableSelected(): boolean {
    return this.filteredLabors
      .filter(l => l.availability === 'Yes')
      .every(l => l.selected);
  }

}
